import { useState, useEffect } from 'react'
import Navbar from '@/components/Navbar'
import WhatsAppButton from '@/components/WhatsAppButton'
import Hero from '@/components/Hero'
import Stats from '@/components/Stats'
import Services from '@/components/Services'
import Portfolio from '@/components/Portfolio'
import Partners from '@/components/Partners'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
import PopupSlider from '@/components/PopupSlider'

export default function Home() {
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  useEffect(() => {
    // Mostrar o popup após 3 segundos
    const timer = setTimeout(() => {
      setIsPopupOpen(true)
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  const handleClosePopup = () => {
    console.log('Fechando popup...');
    setIsPopupOpen(false);
  }

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Portfolio />
        <Partners />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <PopupSlider isOpen={isPopupOpen} onClose={handleClosePopup} />
    </>
  )
}